let pageURLArray = window.location.pathname.split("/").filter(Boolean);
import Codes1 from "./remote1.json";
//import Codes1 from "./remote2.json";
import Codes3 from "./remote3.json";
import Codes4 from "./remote4.json";
import Codes5 from "./remote5.json";

if (pageURLArray[1] === "remote-1") {
  var Codes = Codes1;
} else if (pageURLArray[1] === "remote-2") {
  var Codes = Codes1;
} else if (pageURLArray[1] === "remote-3") {
  var Codes = Codes3;
} else if (pageURLArray[1] === "remote-4") {
  var Codes = Codes4;
} else if (pageURLArray[1] === "remote-5") {
  var Codes = Codes5;
}
const { useState, useEffect } = wp.element;

function RemoteSearchResultsComponent(props) {
  let searchTermSlug = props.searchTermSlug;
  let searchClick = (event) => {
    event.preventDefault();
    $(".code-programming-method").toggleClass("method-active");
    $(".code-search-method").toggleClass("method-active");
  };
  return (
    <div className="search-results-wrapper">
      {Codes &&
        Codes.filter((code) => {
          if (searchTermSlug == null) {
            return code;
          } else if (code.brand.toLowerCase().includes(searchTermSlug.toLowerCase())) {
            if (code.brand.toLowerCase() === searchTermSlug.toLowerCase()) {
              return code;
            }
          }
        }).map((code, index) => {
          return (
            <div className="single-channel-result" key={index}>
              <div
                className={
                  code.popular.length !== 0
                    ? "popular-codes-wrapper popular-active"
                    : "popular-codes-wrapper"
                }
              >
                <p>The following are the most popular code(s) for your {code.brand} TV.</p>
                <div className="popular-code-list">
                  <ul>
                    {code.popular.map((popular, index) => {
                      return <li key={index}>{popular}</li>;
                    })}
                  </ul>
                </div>
              </div>
              <p>
                The following codes may also work with your TV. Codes with a (*) may have only
                limited functionality.
              </p>
              <div className="tv-code-list">
                <ul>
                  {code.tvcodes.map((tvcode, index) => {
                    return <li key={index}>{tvcode}</li>;
                  })}
                </ul>
              </div>
              <div className="code-search-wrapper">
                <p>
                  If none of these codes will operate your TV, try the{" "}
                  <a id="code-search" onClick={() => searchClick(event)} href="#">
                    code search method.
                  </a>
                </p>
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default RemoteSearchResultsComponent;



// WEBPACK FOOTER //
// ./react/components/remote-search/remote-search-results-component.jsx